function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var ModTemplate = require('../../lib/templates/modtemplate');
var SaitoHeader = require('../../lib/saito/ui/saito-header/saito-header');
var Main = require('./lib/ui/main');
var Block = require('./lib/ui/block');
var Supply = require('./lib/ui/supply');
var Address = require('./lib/ui/address');
var Utxo = require('./lib/ui/utxo');
var AllBlocks = require('./lib/ui/all-blocks');
var AllTransactions = require('./lib/ui/all-transactions');
var Search = require('./lib/ui/search');
var ShellTemplate = require('./lib/ui/shell.template');
var _require = require('./lib/ui/transitions'),
  transitionView = _require.transitionView;
var index = require('./index');
var PeerService = require('saito-js/lib/peer_service')["default"];
var _require2 = require('./lib/peer/requests'),
  handleExplorerRequest = _require2.handleExplorerRequest;
var _require3 = require('./lib/peer/client'),
  sendExplorerPeerRequest = _require3.sendExplorerPeerRequest;
var _require4 = require('./lib/peer/response'),
  success = _require4.success,
  failure = _require4.failure;
var ExplorerDatabase = require('./lib/database');
var _require5 = require('./lib/supply-accounting'),
  backfillSupplyStatistics = _require5.backfillSupplyStatistics,
  ensureBlockSupplyIndexed = _require5.ensureBlockSupplyIndexed;
var _require6 = require('./lib/address-index'),
  buildAddressRowsFromBlock = _require6.buildAddressRowsFromBlock,
  blockContainsAtrTransaction = _require6.blockContainsAtrTransaction;
var _require7 = require('./lib/supply-rows'),
  SUPPLY_BLOCK_COUNT = _require7.SUPPLY_BLOCK_COUNT;
var _require8 = require('./lib/explorer-format'),
  extractTransactionsFromBlocks = _require8.extractTransactionsFromBlocks,
  mergeBlockByHash = _require8.mergeBlockByHash;
var _require9 = require('./lib/manual-block-production'),
  EXPLORER_ENSURE_TEST_MODE_REQUEST = _require9.EXPLORER_ENSURE_TEST_MODE_REQUEST,
  EXPLORER_SUBMIT_FEE_TRANSACTION_REQUEST = _require9.EXPLORER_SUBMIT_FEE_TRANSACTION_REQUEST,
  EXPLORER_PRODUCE_BLOCK_REQUEST = _require9.EXPLORER_PRODUCE_BLOCK_REQUEST,
  EXPLORER_PRODUCE_BLOCK_WITH_GT_REQUEST = _require9.EXPLORER_PRODUCE_BLOCK_WITH_GT_REQUEST,
  canShowManualBlockControls = _require9.canShowManualBlockControls;
var _require0 = require('./lib/explorer-test-mode'),
  setExplorerTestMode = _require0.enterExplorerTestMode,
  ensureExplorerTestModeForManualAction = _require0.ensureExplorerTestModeForManualAction,
  runManualBlockProductionRequest = _require0.runManualBlockProductionRequest;
var _require1 = require('./lib/manual-production-countdown'),
  startManualProductionCountdown = _require1.startManualProductionCountdown,
  stopManualProductionCountdown = _require1.stopManualProductionCountdown;
var _require10 = require('./lib/produce-block-without-gt'),
  produceExplorerBlockWithoutGt = _require10.produceExplorerBlockWithoutGt;
var _require11 = require('./lib/produce-block-with-gt'),
  produceExplorerBlockWithGt = _require11.produceExplorerBlockWithGt;
var _require12 = require('./lib/submit-fee-transaction'),
  handleExplorerSubmitFeeTransaction = _require12.handleExplorerSubmitFeeTransaction;
var _require13 = require('./lib/manual-production-log'),
  logManualProduction = _require13.logManualProduction;
var _require14 = require('./lib/api-data'),
  buildExplorerApiData = _require14.buildExplorerApiData;
var Explorer = /*#__PURE__*/function (_ModTemplate) {
  function Explorer(app) {
    var _this;
    _classCallCheck(this, Explorer);
    _this = _callSuper(this, Explorer, [app]);
    _this.name = 'Explorer';
    _this.slug = 'explorer';
    _this.dbname = 'explorer';
    _this.description = 'Saito Blockchain Explorer';
    _this.categories = 'Utilities Information';
    _this.INDEX_BLOCKS = 1;
    _this.INDEX_PUBLICKEYS = 1;
    _this.main = null;
    _this.blockComponent = null;
    _this.supplyComponent = null;
    _this.addressComponent = null;
    _this.utxoComponent = null;
    _this.allBlocksComponent = null;
    _this.allTransactionsComponent = null;
    _this.search = null;
    _this.header = null;
    _this.shellRendered = false;
    _this.activeView = 'home';
    _this.blockHash = null;
    _this.addressPublicKey = null;
    _this.navigationBound = false;
    _this.styles = ['/saito/saito.css', "/".concat(_this.slug, "/style.css")];
    _this.blocks = [];
    _this.transactions = [];
    _this.blocksReady = false;
    _this.transactionsReady = false;
    _this.blocksError = null;
    _this.transactionsError = null;
    _this.explorerPeer = null;
    _this.chainInfo = null;
    _this.chainInfoReady = false;
    _this.chainInfoError = null;
    _this.supplyView = null;
    _this.supplyReady = false;
    _this.supplyError = null;
    _this.addressRows = [];
    _this.addressReady = false;
    _this.addressError = null;
    _this.utxoKey = null;
    _this.utxoResult = null;
    _this.utxoReady = false;
    _this.utxoError = null;
    _this.test_mode = false;
    _this.enable_manual_testing = true;
    _this.manualProduction = null;
    _this.produceUiRequest = null;
    _this.produceUiTimerId = null;
    _this.simulationToolbarMessage = '';
    _this.simulationToolbarIsError = false;
    _this.pendingManualProduceTransactions = [];
    return _this;
  }
  _inherits(Explorer, _ModTemplate);
  return _createClass(Explorer, [{
    key: "returnServices",
    value: function returnServices() {
      var services = [];
      if (this.app.BROWSER == 0) {
        services.push(new PeerService(null, 'Explorer'));
      }
      return services;
    }
  }, {
    key: "getSupplyBalanceSnapshot",
    value: function () {
      var _getSupplyBalanceSnapshot = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var loaded, Saito, instance;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(this.app.BROWSER !== 0)) {
                _context.n = 1;
                break;
              }
              return _context.a(2, null);
            case 1:
              loaded = require('saito-js/saito');
              Saito = loaded["default"] || loaded;
              instance = typeof Saito.getInstance === 'function' ? Saito.getInstance() : null;
              if (!(!instance || typeof instance.getBalanceSnapshot !== 'function')) {
                _context.n = 2;
                break;
              }
              return _context.a(2, null);
            case 2:
              return _context.a(2, instance.getBalanceSnapshot([]));
          }
        }, _callee, this);
      }));
      function getSupplyBalanceSnapshot() {
        return _getSupplyBalanceSnapshot.apply(this, arguments);
      }
      return getSupplyBalanceSnapshot;
    }()
  }, {
    key: "parseRoute",
    value: function parseRoute() {
      var path = window.location.pathname.replace(/\/+$/, '');
      var prefix = "/".concat((this === null || this === void 0 ? void 0 : this.slug) || 'explorer');
      var blockMatch = path.match(new RegExp("^".concat(prefix, "/block/([^/]+)$")));
      var supplyMatch = path.match(new RegExp("^".concat(prefix, "/supply$")));
      var addressMatch = path.match(new RegExp("^".concat(prefix, "/address/([^/]+)$")));
      var utxoMatch = path.match(new RegExp("^".concat(prefix, "/utxo/([^/]+)$")));
      var allBlocksMatch = path.match(new RegExp("^".concat(prefix, "/blocks$")));
      var allTransactionsMatch = path.match(new RegExp("^".concat(prefix, "/transactions$")));
      if (blockMatch) {
        return {
          view: 'block',
          input: decodeURIComponent(blockMatch[1])
        };
      }
      if (supplyMatch) {
        return {
          view: 'supply'
        };
      }
      if (addressMatch) {
        return {
          view: 'address',
          publicKey: decodeURIComponent(addressMatch[1])
        };
      }
      if (utxoMatch) {
        return {
          view: 'utxo',
          utxokey: decodeURIComponent(utxoMatch[1])
        };
      }
      if (allBlocksMatch) {
        return {
          view: 'allBlocks'
        };
      }
      if (allTransactionsMatch) {
        return {
          view: 'allTransactions'
        };
      }
      return {
        view: 'home'
      };
    }
  }, {
    key: "ensureShell",
    value: function ensureShell() {
      if (this.shellRendered) {
        return;
      }
      var container = document.querySelector('.saito-container');
      if (container) {
        container.classList.add('explorer-container');
      }
      this.app.browser.replaceElementContentBySelector(ShellTemplate(), '.saito-container');
      this.shellRendered = true;
      if (!this.search) {
        this.search = new Search(this.app, this);
      }
      this.search.render('.explorer-search');
      this.renderSimulationToolbar();
    }
  }, {
    key: "bindNavigation",
    value: function bindNavigation() {
      var _this2 = this;
      if (this.navigationBound || !this.browser_active) {
        return;
      }
      this.navigationBound = true;
      document.addEventListener('click', function (event) {
        if (!_this2.browser_active) {
          return;
        }
        var backBtn = event.target.closest('[data-nav="home"], [data-explorer-nav="home"]');
        if (backBtn) {
          event.preventDefault();
          event.stopPropagation();
          _this2.renderHome({
            pushState: true,
            animate: true
          });
          return;
        }
        var pubkeyLink = event.target.closest('.explorer-pubkey-link[data-public-key]');
        if (pubkeyLink) {
          event.preventDefault();
          event.stopPropagation();
          var publicKey = pubkeyLink.getAttribute('data-public-key');
          if (publicKey) {
            _this2.renderAddress(publicKey, {
              pushState: true,
              animate: true
            });
          }
          return;
        }
        var utxoLink = event.target.closest('.explorer-utxokey-link[data-utxokey]');
        if (utxoLink) {
          event.preventDefault();
          event.stopPropagation();
          var utxokey = utxoLink.getAttribute('data-utxokey');
          if (utxokey) {
            _this2.renderUtxo(utxokey, {
              pushState: true,
              animate: true
            });
          }
          return;
        }
        var txBlockLink = event.target.closest('.explorer-tx-block-link[data-block-input]');
        if (txBlockLink) {
          event.preventDefault();
          event.stopPropagation();
          var input = txBlockLink.getAttribute('data-block-input');
          if (input) {
            _this2.renderBlock(input, {
              pushState: true,
              animate: true
            });
          }
          return;
        }
        var copyBtn = event.target.closest('.explorer-copy-btn[data-copy]');
        if (copyBtn) {
          event.preventDefault();
          event.stopPropagation();
          var text = copyBtn.getAttribute('data-copy') || '';
          if (text) {
            var _navigator$clipboard;
            var done = function done() {
              if (typeof siteMessage === 'function') {
                siteMessage('Copied', 1500);
              }
            };
            if ((_navigator$clipboard = navigator.clipboard) !== null && _navigator$clipboard !== void 0 && _navigator$clipboard.writeText) {
              navigator.clipboard.writeText(text).then(done)["catch"](function () {});
            } else {
              var ta = document.createElement('textarea');
              ta.value = text;
              document.body.appendChild(ta);
              ta.select();
              document.execCommand('copy');
              ta.remove();
              done();
            }
          }
          return;
        }
        var link = event.target.closest('.explorer-footer-link');
        if (link) {
          var href = link.getAttribute('href') || '';
          if (href.endsWith('/explorer/supply')) {
            event.preventDefault();
            _this2.renderSupply({
              pushState: true,
              animate: true
            });
          }
          return;
        }
        var viewAllLink = event.target.closest('[data-explorer-nav]');
        if (viewAllLink) {
          var nav = viewAllLink.getAttribute('data-explorer-nav');
          if (nav === 'all-blocks') {
            event.preventDefault();
            event.stopPropagation();
            _this2.renderAllBlocks({
              pushState: true,
              animate: true
            });
          } else if (nav === 'all-transactions') {
            event.preventDefault();
            event.stopPropagation();
            _this2.renderAllTransactions({
              pushState: true,
              animate: true
            });
          }
        }
      });
      window.addEventListener('popstate', function (event) {
        var state = event.state || _this2.parseRoute();
        if (state.view === 'block' && (state.input || state.hash)) {
          _this2.renderBlock(state.input || state.hash, {
            pushState: false,
            animate: true,
            expandTxSignature: state.expandTxSignature || null
          });
          return;
        }
        if (state.view === 'supply') {
          _this2.renderSupply({
            pushState: false,
            animate: true
          });
          return;
        }
        if (state.view === 'address' && state.publicKey) {
          _this2.renderAddress(state.publicKey, {
            pushState: false,
            animate: true
          });
          return;
        }
        if (state.view === 'utxo' && state.utxokey) {
          _this2.renderUtxo(state.utxokey, {
            pushState: false,
            animate: true
          });
          return;
        }
        if (state.view === 'allBlocks') {
          _this2.renderAllBlocks({
            pushState: false,
            animate: true
          });
          return;
        }
        if (state.view === 'allTransactions') {
          _this2.renderAllTransactions({
            pushState: false,
            animate: true
          });
          return;
        }
        _this2.renderHome({
          pushState: false,
          animate: true
        });
      });
    }
  }, {
    key: "getViewElement",
    value: function getViewElement() {
      return document.querySelector('.explorer-view');
    }
  }, {
    key: "cleanupListViews",
    value: function cleanupListViews() {
      if (this.allBlocksComponent) {
        this.allBlocksComponent.cleanup();
        this.allBlocksComponent = null;
      }
      if (this.allTransactionsComponent) {
        this.allTransactionsComponent.cleanup();
        this.allTransactionsComponent = null;
      }
    }
  }, {
    key: "renderHome",
    value: function () {
      var _renderHome = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this3 = this;
        var options,
          _options$pushState,
          pushState,
          _options$animate,
          animate,
          renderContent,
          _args2 = arguments;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              options = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
              _options$pushState = options.pushState, pushState = _options$pushState === void 0 ? true : _options$pushState, _options$animate = options.animate, animate = _options$animate === void 0 ? true : _options$animate;
              this.activeView = 'home';
              this.blockHash = null;
              this.blockComponent = null;
              this.supplyComponent = null;
              this.addressComponent = null;
              this.addressPublicKey = null;
              this.utxoComponent = null;
              this.utxoKey = null;
              this.cleanupListViews();
              if (pushState) {
                window.history.pushState({
                  view: 'home'
                }, '', "/".concat(this.slug));
              }
              this.ensureShell();
              renderContent = function renderContent() {
                if (!_this3.main) {
                  _this3.main = new Main(_this3.app, _this3);
                }
                _this3.main.render('.explorer-view');
              };
              if (!animate) {
                _context2.n = 2;
                break;
              }
              _context2.n = 1;
              return transitionView(this.getViewElement(), renderContent);
            case 1:
              _context2.n = 3;
              break;
            case 2:
              renderContent();
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function renderHome() {
        return _renderHome.apply(this, arguments);
      }
      return renderHome;
    }()
  }, {
    key: "renderSupply",
    value: function () {
      var _renderSupply = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this4 = this;
        var options,
          _options$pushState2,
          pushState,
          _options$animate2,
          animate,
          renderContent,
          _args3 = arguments;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              options = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
              _options$pushState2 = options.pushState, pushState = _options$pushState2 === void 0 ? true : _options$pushState2, _options$animate2 = options.animate, animate = _options$animate2 === void 0 ? true : _options$animate2;
              this.activeView = 'supply';
              this.blockHash = null;
              this.blockComponent = null;
              this.main = null;
              this.supplyView = null;
              this.supplyReady = false;
              this.supplyError = null;
              this.addressComponent = null;
              this.addressPublicKey = null;
              this.utxoComponent = null;
              this.utxoKey = null;
              this.cleanupListViews();
              if (pushState) {
                window.history.pushState({
                  view: 'supply'
                }, '', "/".concat(this.slug, "/supply"));
              }
              this.ensureShell();
              renderContent = function renderContent() {
                if (!_this4.supplyComponent) {
                  _this4.supplyComponent = new Supply(_this4.app, _this4);
                }
                _this4.supplyComponent.render('.explorer-view');
              };
              if (!animate) {
                _context3.n = 2;
                break;
              }
              _context3.n = 1;
              return transitionView(this.getViewElement(), renderContent);
            case 1:
              _context3.n = 3;
              break;
            case 2:
              renderContent();
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function renderSupply() {
        return _renderSupply.apply(this, arguments);
      }
      return renderSupply;
    }()
  }, {
    key: "renderAddress",
    value: function () {
      var _renderAddress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(publicKey) {
        var _this5 = this;
        var options,
          _options$pushState3,
          pushState,
          _options$animate3,
          animate,
          renderContent,
          _args4 = arguments;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              options = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
              _options$pushState3 = options.pushState, pushState = _options$pushState3 === void 0 ? true : _options$pushState3, _options$animate3 = options.animate, animate = _options$animate3 === void 0 ? true : _options$animate3;
              if (publicKey) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              this.activeView = 'address';
              this.addressPublicKey = publicKey;
              this.blockHash = null;
              this.blockComponent = null;
              this.main = null;
              this.supplyComponent = null;
              this.addressRows = [];
              this.addressReady = false;
              this.addressError = null;
              this.utxoComponent = null;
              this.utxoKey = null;
              this.cleanupListViews();
              if (pushState) {
                window.history.pushState({
                  view: 'address',
                  publicKey: publicKey
                }, '', "/".concat(this.slug, "/address/").concat(encodeURIComponent(publicKey)));
              }
              this.ensureShell();
              renderContent = function renderContent() {
                _this5.addressComponent = new Address(_this5.app, _this5, publicKey);
                _this5.addressComponent.render('.explorer-view');
              };
              if (!animate) {
                _context4.n = 3;
                break;
              }
              _context4.n = 2;
              return transitionView(this.getViewElement(), renderContent);
            case 2:
              _context4.n = 4;
              break;
            case 3:
              renderContent();
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function renderAddress(_x) {
        return _renderAddress.apply(this, arguments);
      }
      return renderAddress;
    }()
  }, {
    key: "renderUtxo",
    value: function () {
      var _renderUtxo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(utxokey) {
        var _this6 = this;
        var options,
          _options$pushState4,
          pushState,
          _options$animate4,
          animate,
          renderContent,
          _args5 = arguments;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              options = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
              _options$pushState4 = options.pushState, pushState = _options$pushState4 === void 0 ? true : _options$pushState4, _options$animate4 = options.animate, animate = _options$animate4 === void 0 ? true : _options$animate4;
              if (utxokey) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              this.activeView = 'utxo';
              this.utxoKey = utxokey;
              this.utxoResult = null;
              this.utxoReady = false;
              this.utxoError = null;
              this.blockHash = null;
              this.blockComponent = null;
              this.main = null;
              this.supplyComponent = null;
              this.addressComponent = null;
              this.addressPublicKey = null;
              this.cleanupListViews();
              if (pushState) {
                window.history.pushState({
                  view: 'utxo',
                  utxokey: utxokey
                }, '', "/".concat(this.slug, "/utxo/").concat(encodeURIComponent(utxokey)));
              }
              this.ensureShell();
              renderContent = function renderContent() {
                _this6.utxoComponent = new Utxo(_this6.app, _this6, utxokey);
                _this6.utxoComponent.render('.explorer-view');
              };
              if (!animate) {
                _context5.n = 3;
                break;
              }
              _context5.n = 2;
              return transitionView(this.getViewElement(), renderContent);
            case 2:
              _context5.n = 4;
              break;
            case 3:
              renderContent();
            case 4:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function renderUtxo(_x2) {
        return _renderUtxo.apply(this, arguments);
      }
      return renderUtxo;
    }()
  }, {
    key: "resolveBlockHash",
    value: function resolveBlockHash() {
      var blockHash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var blockId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      if (blockHash) {
        return blockHash;
      }
      if (blockId == null || blockId === '') {
        return null;
      }
      var block = (this.blocks || []).find(function (entry) {
        return String(entry === null || entry === void 0 ? void 0 : entry.id) === String(blockId);
      });
      return (block === null || block === void 0 ? void 0 : block.hash) || null;
    }
  }, {
    key: "renderBlock",
    value: function () {
      var _renderBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(input) {
        var _this7 = this;
        var options,
          _options$pushState5,
          pushState,
          _options$animate5,
          animate,
          _options$expandTxSign,
          expandTxSignature,
          url,
          renderContent,
          _args6 = arguments;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              options = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {};
              _options$pushState5 = options.pushState, pushState = _options$pushState5 === void 0 ? true : _options$pushState5, _options$animate5 = options.animate, animate = _options$animate5 === void 0 ? true : _options$animate5, _options$expandTxSign = options.expandTxSignature, expandTxSignature = _options$expandTxSign === void 0 ? null : _options$expandTxSign;
              if (input) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2);
            case 1:
              this.activeView = 'block';
              this.blockHash = input;
              this.supplyComponent = null;
              this.addressComponent = null;
              this.addressPublicKey = null;
              this.utxoComponent = null;
              this.utxoKey = null;
              this.cleanupListViews();
              if (pushState) {
                url = "/".concat(this.slug, "/block/").concat(encodeURIComponent(input));
                window.history.pushState({
                  view: 'block',
                  input: input,
                  hash: input,
                  expandTxSignature: expandTxSignature
                }, '', url);
              }
              this.ensureShell();
              renderContent = function renderContent() {
                _this7.blockComponent = new Block(_this7.app, _this7, input, expandTxSignature);
                _this7.blockComponent.render('.explorer-view');
              };
              if (!animate) {
                _context6.n = 3;
                break;
              }
              _context6.n = 2;
              return transitionView(this.getViewElement(), renderContent);
            case 2:
              _context6.n = 4;
              break;
            case 3:
              renderContent();
            case 4:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function renderBlock(_x3) {
        return _renderBlock.apply(this, arguments);
      }
      return renderBlock;
    }()
  }, {
    key: "renderAllBlocks",
    value: function () {
      var _renderAllBlocks = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _this8 = this;
        var options,
          _options$pushState6,
          pushState,
          _options$animate6,
          animate,
          renderContent,
          _args7 = arguments;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              options = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
              _options$pushState6 = options.pushState, pushState = _options$pushState6 === void 0 ? true : _options$pushState6, _options$animate6 = options.animate, animate = _options$animate6 === void 0 ? true : _options$animate6;
              this.activeView = 'allBlocks';
              this.blockHash = null;
              this.blockComponent = null;
              this.main = null;
              this.supplyComponent = null;
              this.addressComponent = null;
              this.addressPublicKey = null;
              this.utxoComponent = null;
              this.utxoKey = null;
              this.cleanupListViews();
              if (pushState) {
                window.history.pushState({
                  view: 'allBlocks'
                }, '', "/".concat(this.slug, "/blocks"));
              }
              this.ensureShell();
              renderContent = function renderContent() {
                _this8.allBlocksComponent = new AllBlocks(_this8.app, _this8);
                _this8.allBlocksComponent.render('.explorer-view');
              };
              if (!animate) {
                _context7.n = 2;
                break;
              }
              _context7.n = 1;
              return transitionView(this.getViewElement(), renderContent);
            case 1:
              _context7.n = 3;
              break;
            case 2:
              renderContent();
            case 3:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function renderAllBlocks() {
        return _renderAllBlocks.apply(this, arguments);
      }
      return renderAllBlocks;
    }()
  }, {
    key: "renderAllTransactions",
    value: function () {
      var _renderAllTransactions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var _this9 = this;
        var options,
          _options$pushState7,
          pushState,
          _options$animate7,
          animate,
          renderContent,
          _args8 = arguments;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              options = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
              _options$pushState7 = options.pushState, pushState = _options$pushState7 === void 0 ? true : _options$pushState7, _options$animate7 = options.animate, animate = _options$animate7 === void 0 ? true : _options$animate7;
              this.activeView = 'allTransactions';
              this.blockHash = null;
              this.blockComponent = null;
              this.main = null;
              this.supplyComponent = null;
              this.addressComponent = null;
              this.addressPublicKey = null;
              this.utxoComponent = null;
              this.utxoKey = null;
              this.cleanupListViews();
              if (pushState) {
                window.history.pushState({
                  view: 'allTransactions'
                }, '', "/".concat(this.slug, "/transactions"));
              }
              this.ensureShell();
              renderContent = function renderContent() {
                _this9.allTransactionsComponent = new AllTransactions(_this9.app, _this9);
                _this9.allTransactionsComponent.render('.explorer-view');
              };
              if (!animate) {
                _context8.n = 2;
                break;
              }
              _context8.n = 1;
              return transitionView(this.getViewElement(), renderContent);
            case 1:
              _context8.n = 3;
              break;
            case 2:
              renderContent();
            case 3:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function renderAllTransactions() {
        return _renderAllTransactions.apply(this, arguments);
      }
      return renderAllTransactions;
    }()
  }, {
    key: "resetExplorerData",
    value: function resetExplorerData() {
      this.blocksReady = false;
      this.transactionsReady = false;
      this.blocksError = null;
      this.transactionsError = null;
      this.blocks = [];
      this.transactions = [];
      this.chainInfo = null;
      this.chainInfoReady = false;
      this.chainInfoError = null;
      this.supplyView = null;
      this.supplyReady = false;
      this.supplyError = null;
      this.addressRows = [];
      this.addressReady = false;
      this.addressError = null;
      this.utxoResult = null;
      this.utxoReady = false;
      this.utxoError = null;
    }
  }, {
    key: "onPeerServiceUp",
    value: function () {
      var _onPeerServiceUp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(app, peer) {
        var service,
          _args9 = arguments;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              service = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : {};
              if (!(!app.BROWSER || !this.browser_active)) {
                _context9.n = 1;
                break;
              }
              return _context9.a(2);
            case 1:
              if (!(service.service !== 'Explorer')) {
                _context9.n = 2;
                break;
              }
              return _context9.a(2);
            case 2:
              this.explorerPeer = peer;
              this.resetExplorerData();
              if (!(this.activeView === 'allBlocks')) {
                _context9.n = 3;
                break;
              }
              this.cleanupListViews();
              this.allBlocksComponent = new AllBlocks(this.app, this);
              this.allBlocksComponent.render('.explorer-view');
              return _context9.a(2);
            case 3:
              if (!(this.activeView === 'allTransactions')) {
                _context9.n = 4;
                break;
              }
              this.cleanupListViews();
              this.allTransactionsComponent = new AllTransactions(this.app, this);
              this.allTransactionsComponent.render('.explorer-view');
              return _context9.a(2);
            case 4:
              _context9.n = 5;
              return this.requestExplorerOverview(app, peer);
            case 5:
              return _context9.a(2);
          }
        }, _callee9, this);
      }));
      function onPeerServiceUp(_x4, _x5) {
        return _onPeerServiceUp.apply(this, arguments);
      }
      return onPeerServiceUp;
    }()
  }, {
    key: "refreshHomeData",
    value: function () {
      var _refreshHomeData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              if (!(this.activeView !== 'home' || !this.explorerPeer)) {
                _context0.n = 1;
                break;
              }
              return _context0.a(2);
            case 1:
              this.resetExplorerData();
              _context0.n = 2;
              return this.requestExplorerOverview(this.app, this.explorerPeer);
            case 2:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function refreshHomeData() {
        return _refreshHomeData.apply(this, arguments);
      }
      return refreshHomeData;
    }()
  }, {
    key: "requestExplorerOverview",
    value: function () {
      var _requestExplorerOverview = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(app, peer) {
        var _this0 = this;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              _context10.n = 1;
              return this.refreshActiveView();
            case 1:
              this.fetchChainInfo(app, peer);
              sendExplorerPeerRequest(app, 'request blocks', {
                data: {
                  request: 'request blocks',
                  count: 10,
                  include_offchain: false
                },
                callback: function () {
                  var _callback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(response) {
                    return _regenerator().w(function (_context1) {
                      while (1) switch (_context1.n) {
                        case 0:
                          if (!(response !== null && response !== void 0 && response.err)) {
                            _context1.n = 2;
                            break;
                          }
                          console.error('Explorer: block request failed (network)', {
                            peer: peer === null || peer === void 0 ? void 0 : peer.publicKey,
                            error: response.err,
                            response: response
                          });
                          _this0.blocksError = 'Network error while fetching blocks.';
                          _this0.blocksReady = true;
                          _this0.transactionsError = 'Network error while fetching transactions.';
                          _this0.transactionsReady = true;
                          _context1.n = 1;
                          return _this0.refreshActiveView();
                        case 1:
                          return _context1.a(2);
                        case 2:
                          if (response !== null && response !== void 0 && response.success) {
                            _context1.n = 4;
                            break;
                          }
                          console.error('Explorer: block request failed', {
                            peer: peer === null || peer === void 0 ? void 0 : peer.publicKey,
                            error: (response === null || response === void 0 ? void 0 : response.error) || 'unknown error',
                            response: response
                          });
                          _this0.blocksError = (response === null || response === void 0 ? void 0 : response.error) || 'Failed to fetch blocks from Explorer peer.';
                          _this0.blocksReady = true;
                          _this0.transactionsError = 'Waiting for block data before loading transactions.';
                          _this0.transactionsReady = true;
                          _context1.n = 3;
                          return _this0.refreshActiveView();
                        case 3:
                          return _context1.a(2);
                        case 4:
                          _this0.blocks = Array.isArray(response.data) ? response.data : [];
                          _this0.blocksReady = true;
                          _context1.n = 5;
                          return _this0.refreshActiveView();
                        case 5:
                          _context1.n = 6;
                          return _this0.fetchTransactionData(app, peer);
                        case 6:
                          if (!(_this0.activeView === 'supply')) {
                            _context1.n = 7;
                            break;
                          }
                          _context1.n = 7;
                          return _this0.fetchSupplyData(app, peer);
                        case 7:
                          if (!(_this0.activeView === 'address' && _this0.addressPublicKey)) {
                            _context1.n = 8;
                            break;
                          }
                          _context1.n = 8;
                          return _this0.fetchAddressData(app, peer, _this0.addressPublicKey);
                        case 8:
                          if (!(_this0.activeView === 'utxo' && _this0.utxoKey)) {
                            _context1.n = 9;
                            break;
                          }
                          _context1.n = 9;
                          return _this0.fetchUtxoData(app, peer, _this0.utxoKey);
                        case 9:
                          return _context1.a(2);
                      }
                    }, _callee1);
                  }));
                  function callback(_x8) {
                    return _callback.apply(this, arguments);
                  }
                  return callback;
                }(),
                peer: peer
              });
            case 2:
              return _context10.a(2);
          }
        }, _callee10, this);
      }));
      function requestExplorerOverview(_x6, _x7) {
        return _requestExplorerOverview.apply(this, arguments);
      }
      return requestExplorerOverview;
    }()
  }, {
    key: "fetchSupplyData",
    value: function fetchSupplyData(app, peer) {
      var _this1 = this;
      this.supplyReady = false;
      this.supplyError = null;
      this.supplyView = null;
      return new Promise(function (resolve) {
        sendExplorerPeerRequest(app, 'request supply', {
          data: {
            request: 'request supply',
            count: SUPPLY_BLOCK_COUNT
          },
          callback: function () {
            var _callback2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(response) {
              return _regenerator().w(function (_context11) {
                while (1) switch (_context11.n) {
                  case 0:
                    if (!(response !== null && response !== void 0 && response.err)) {
                      _context11.n = 2;
                      break;
                    }
                    console.error('Explorer: supply request failed (network)', {
                      peer: peer === null || peer === void 0 ? void 0 : peer.publicKey,
                      error: response.err,
                      response: response
                    });
                    _this1.supplyError = 'Network error while fetching supply data.';
                    _this1.supplyReady = true;
                    _context11.n = 1;
                    return _this1.refreshActiveView();
                  case 1:
                    resolve();
                    return _context11.a(2);
                  case 2:
                    if (response !== null && response !== void 0 && response.success) {
                      _context11.n = 4;
                      break;
                    }
                    console.error('Explorer: supply request failed', {
                      peer: peer === null || peer === void 0 ? void 0 : peer.publicKey,
                      error: (response === null || response === void 0 ? void 0 : response.error) || 'unknown error',
                      response: response
                    });
                    _this1.supplyError = (response === null || response === void 0 ? void 0 : response.error) || 'Failed to fetch supply data from Explorer peer.';
                    _this1.supplyReady = true;
                    _context11.n = 3;
                    return _this1.refreshActiveView();
                  case 3:
                    resolve();
                    return _context11.a(2);
                  case 4:
                    _this1.supplyView = response.data && _typeof(response.data) === 'object' ? response.data : null;
                    _this1.supplyReady = true;
                    _context11.n = 5;
                    return _this1.refreshActiveView();
                  case 5:
                    resolve();
                  case 6:
                    return _context11.a(2);
                }
              }, _callee11);
            }));
            function callback(_x9) {
              return _callback2.apply(this, arguments);
            }
            return callback;
          }(),
          peer: peer
        });
      });
    }
  }, {
    key: "fetchAddressData",
    value: function fetchAddressData(app, peer, publicKey) {
      var _this10 = this;
      this.addressReady = false;
      this.addressError = null;
      this.addressRows = [];
      return new Promise(function (resolve) {
        sendExplorerPeerRequest(app, 'request address', {
          data: {
            request: 'request address',
            publickey: String(publicKey),
            count: 100
          },
          callback: function () {
            var _callback3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(response) {
              var _response$data;
              return _regenerator().w(function (_context12) {
                while (1) switch (_context12.n) {
                  case 0:
                    if (!(response !== null && response !== void 0 && response.err)) {
                      _context12.n = 2;
                      break;
                    }
                    console.error('Explorer: address request failed (network)', {
                      peer: peer === null || peer === void 0 ? void 0 : peer.publicKey,
                      error: response.err,
                      response: response
                    });
                    _this10.addressError = 'Network error while fetching address activity.';
                    _this10.addressReady = true;
                    _context12.n = 1;
                    return _this10.refreshActiveView();
                  case 1:
                    resolve();
                    return _context12.a(2);
                  case 2:
                    if (response !== null && response !== void 0 && response.success) {
                      _context12.n = 4;
                      break;
                    }
                    console.error('Explorer: address request failed', {
                      peer: peer === null || peer === void 0 ? void 0 : peer.publicKey,
                      error: (response === null || response === void 0 ? void 0 : response.error) || 'unknown error',
                      response: response
                    });
                    _this10.addressError = (response === null || response === void 0 ? void 0 : response.error) || 'Failed to fetch address activity from Explorer peer.';
                    _this10.addressReady = true;
                    _context12.n = 3;
                    return _this10.refreshActiveView();
                  case 3:
                    resolve();
                    return _context12.a(2);
                  case 4:
                    _this10.addressRows = Array.isArray((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.rows) ? response.data.rows : [];
                    _this10.addressReady = true;
                    _context12.n = 5;
                    return _this10.refreshActiveView();
                  case 5:
                    resolve();
                  case 6:
                    return _context12.a(2);
                }
              }, _callee12);
            }));
            function callback(_x0) {
              return _callback3.apply(this, arguments);
            }
            return callback;
          }(),
          peer: peer
        });
      });
    }
  }, {
    key: "fetchUtxoData",
    value: function fetchUtxoData(app, peer, utxokey) {
      var _this11 = this;
      this.utxoReady = false;
      this.utxoError = null;
      this.utxoResult = null;
      return new Promise(function (resolve) {
        sendExplorerPeerRequest(app, 'request utxo', {
          data: {
            request: 'request utxo',
            utxokey: String(utxokey)
          },
          callback: function () {
            var _callback4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(response) {
              return _regenerator().w(function (_context13) {
                while (1) switch (_context13.n) {
                  case 0:
                    if (!(response !== null && response !== void 0 && response.err)) {
                      _context13.n = 2;
                      break;
                    }
                    console.error('Explorer: utxo request failed (network)', {
                      peer: peer === null || peer === void 0 ? void 0 : peer.publicKey,
                      error: response.err,
                      response: response
                    });
                    _this11.utxoError = 'Network error while looking up UTXO.';
                    _this11.utxoReady = true;
                    _context13.n = 1;
                    return _this11.refreshActiveView();
                  case 1:
                    resolve();
                    return _context13.a(2);
                  case 2:
                    if (response !== null && response !== void 0 && response.success) {
                      _context13.n = 4;
                      break;
                    }
                    console.error('Explorer: utxo request failed', {
                      peer: peer === null || peer === void 0 ? void 0 : peer.publicKey,
                      error: (response === null || response === void 0 ? void 0 : response.error) || 'unknown error',
                      response: response
                    });
                    _this11.utxoError = (response === null || response === void 0 ? void 0 : response.error) || 'Failed to look up UTXO from Explorer peer.';
                    _this11.utxoReady = true;
                    _context13.n = 3;
                    return _this11.refreshActiveView();
                  case 3:
                    resolve();
                    return _context13.a(2);
                  case 4:
                    _this11.utxoResult = response.data || null;
                    _this11.utxoReady = true;
                    _context13.n = 5;
                    return _this11.refreshActiveView();
                  case 5:
                    resolve();
                  case 6:
                    return _context13.a(2);
                }
              }, _callee13);
            }));
            function callback(_x1) {
              return _callback4.apply(this, arguments);
            }
            return callback;
          }(),
          peer: peer
        });
      });
    }
  }, {
    key: "requestBlockFromPeerPromise",
    value: function requestBlockFromPeerPromise(app, peer, identifier) {
      var includeTransactions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var data = {
        request: 'request block',
        include_transactions: includeTransactions
      };
      if (typeof identifier === 'bigint' || typeof identifier === 'number') {
        data.block_id = String(identifier);
      } else {
        data.hash = String(identifier);
      }
      return new Promise(function (resolve) {
        sendExplorerPeerRequest(app, 'request block', {
          data: data,
          callback: function callback(response) {
            if (response !== null && response !== void 0 && response.success && response.data) {
              resolve(response.data);
              return;
            }
            resolve(null);
          },
          peer: peer
        });
      });
    }
  }, {
    key: "fetchTransactionData",
    value: function () {
      var _fetchTransactionData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(app, peer) {
        var _this$blocks;
        var fetchCount, requests, i, block, id, results, enrichedBlocks, _i, fullBlock, _t;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.p = _context14.n) {
            case 0:
              this.transactionsReady = false;
              this.transactionsError = null;
              this.transactions = [];
              if ((_this$blocks = this.blocks) !== null && _this$blocks !== void 0 && _this$blocks.length) {
                _context14.n = 2;
                break;
              }
              this.transactionsReady = true;
              _context14.n = 1;
              return this.refreshActiveView();
            case 1:
              return _context14.a(2);
            case 2:
              fetchCount = Math.min(5, this.blocks.length);
              _context14.p = 3;
              requests = [];
              i = 0;
            case 4:
              if (!(i < fetchCount)) {
                _context14.n = 7;
                break;
              }
              block = this.blocks[i];
              id = (block === null || block === void 0 ? void 0 : block.hash) || (block === null || block === void 0 ? void 0 : block.id);
              if (!(id == null || id === '')) {
                _context14.n = 5;
                break;
              }
              return _context14.a(3, 6);
            case 5:
              requests.push(this.requestBlockFromPeerPromise(app, peer, id, true));
            case 6:
              i++;
              _context14.n = 4;
              break;
            case 7:
              _context14.n = 8;
              return Promise.all(requests);
            case 8:
              results = _context14.v;
              enrichedBlocks = this.blocks.slice();
              for (_i = 0; _i < results.length; _i++) {
                fullBlock = results[_i];
                if (fullBlock) {
                  enrichedBlocks = mergeBlockByHash(enrichedBlocks, fullBlock);
                }
              }
              this.blocks = enrichedBlocks;
              this.transactions = extractTransactionsFromBlocks(enrichedBlocks);
              this.transactionsReady = true;
              _context14.n = 10;
              break;
            case 9:
              _context14.p = 9;
              _t = _context14.v;
              console.error('Explorer: failed to fetch transaction data', _t);
              this.transactionsError = 'Failed to load recent transactions.';
              this.transactionsReady = true;
            case 10:
              _context14.n = 11;
              return this.refreshActiveView();
            case 11:
              return _context14.a(2);
          }
        }, _callee14, this, [[3, 9]]);
      }));
      function fetchTransactionData(_x10, _x11) {
        return _fetchTransactionData.apply(this, arguments);
      }
      return fetchTransactionData;
    }()
  }, {
    key: "fetchChainInfo",
    value: function fetchChainInfo(app, peer) {
      var _this12 = this;
      this.chainInfoReady = false;
      this.chainInfoError = null;
      this.chainInfo = null;
      return new Promise(function (resolve) {
        sendExplorerPeerRequest(app, 'request info', {
          data: {
            request: 'request info'
          },
          callback: function () {
            var _callback5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(response) {
              return _regenerator().w(function (_context15) {
                while (1) switch (_context15.n) {
                  case 0:
                    if (!(response !== null && response !== void 0 && response.err)) {
                      _context15.n = 2;
                      break;
                    }
                    _this12.chainInfoError = 'Network error while fetching blockchain information.';
                    _this12.chainInfoReady = true;
                    _context15.n = 1;
                    return _this12.refreshActiveView();
                  case 1:
                    resolve();
                    return _context15.a(2);
                  case 2:
                    if (response !== null && response !== void 0 && response.success) {
                      _context15.n = 4;
                      break;
                    }
                    _this12.chainInfoError = (response === null || response === void 0 ? void 0 : response.error) || 'Failed to fetch blockchain information from Explorer peer.';
                    _this12.chainInfoReady = true;
                    _context15.n = 3;
                    return _this12.refreshActiveView();
                  case 3:
                    resolve();
                    return _context15.a(2);
                  case 4:
                    _this12.chainInfo = response.data || null;
                    _this12.chainInfoReady = true;
                    _context15.n = 5;
                    return _this12.refreshActiveView();
                  case 5:
                    resolve();
                  case 6:
                    return _context15.a(2);
                }
              }, _callee15);
            }));
            function callback(_x12) {
              return _callback5.apply(this, arguments);
            }
            return callback;
          }(),
          peer: peer
        });
      });
    }
  }, {
    key: "refreshActiveView",
    value: function () {
      var _refreshActiveView = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16() {
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.n) {
            case 0:
              if (!(this.activeView === 'home' && this.main)) {
                _context16.n = 1;
                break;
              }
              this.main.render('.explorer-view');
              return _context16.a(2);
            case 1:
              if (!(this.activeView === 'supply' && this.supplyComponent)) {
                _context16.n = 2;
                break;
              }
              this.supplyComponent.paint();
              return _context16.a(2);
            case 2:
              if (!(this.activeView === 'address' && this.addressComponent)) {
                _context16.n = 3;
                break;
              }
              this.addressComponent.paint();
              return _context16.a(2);
            case 3:
              if (this.activeView === 'utxo' && this.utxoComponent) {
                this.utxoComponent.paint();
              }
            case 4:
              return _context16.a(2);
          }
        }, _callee16, this);
      }));
      function refreshActiveView() {
        return _refreshActiveView.apply(this, arguments);
      }
      return refreshActiveView;
    }()
  }, {
    key: "canExposeManualBlockProduction",
    value: function canExposeManualBlockProduction() {
      return canShowManualBlockControls(this.app, this);
    }
  }, {
    key: "setSimulationToolbarMessage",
    value: function setSimulationToolbarMessage(message) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$isError = _ref.isError,
        isError = _ref$isError === void 0 ? false : _ref$isError;
      this.simulationToolbarMessage = message || '';
      this.simulationToolbarIsError = Boolean(isError);
      this.renderSimulationToolbar();
    }
  }, {
    key: "clearSimulationToolbarMessage",
    value: function clearSimulationToolbarMessage() {
      this.setSimulationToolbarMessage('');
    }
  }, {
    key: "renderSimulationToolbar",
    value: function renderSimulationToolbar() {
      if (!this.browser_active) {
        return;
      }
      var el = document.querySelector('[data-explorer-simulation-status]');
      if (!el) {
        return;
      }
      el.textContent = this.simulationToolbarMessage || '';
      el.classList.toggle('is-error', Boolean(this.simulationToolbarIsError && this.simulationToolbarMessage));
    }
  }, {
    key: "refreshSupplyAfterProduce",
    value: function () {
      var _refreshSupplyAfterProduce = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17() {
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.n) {
            case 0:
              if (!(this.activeView === 'supply' && this.explorerPeer)) {
                _context17.n = 2;
                break;
              }
              _context17.n = 1;
              return this.fetchSupplyData(this.app, this.explorerPeer);
            case 1:
              _context17.n = 3;
              break;
            case 2:
              if (this.activeView === 'supply' && this.supplyComponent) {
                this.supplyComponent.paint();
              }
            case 3:
              return _context17.a(2);
          }
        }, _callee17, this);
      }));
      function refreshSupplyAfterProduce() {
        return _refreshSupplyAfterProduce.apply(this, arguments);
      }
      return refreshSupplyAfterProduce;
    }()
  }, {
    key: "getBrowserLatestBlockId",
    value: function () {
      var _getBrowserLatestBlockId = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18() {
        var blocks, latest, blockId, _t2;
        return _regenerator().w(function (_context18) {
          while (1) switch (_context18.p = _context18.n) {
            case 0:
              _context18.p = 0;
              _context18.n = 1;
              return this.app.core.blockchain.getBlocks(1, false);
            case 1:
              blocks = _context18.v;
              latest = Array.isArray(blocks) && blocks.length ? blocks[0] : null;
              blockId = Number(latest === null || latest === void 0 ? void 0 : latest.id);
              return _context18.a(2, Number.isFinite(blockId) ? blockId : 0);
            case 2:
              _context18.p = 2;
              _t2 = _context18.v;
              return _context18.a(2, 0);
          }
        }, _callee18, this, [[0, 2]]);
      }));
      function getBrowserLatestBlockId() {
        return _getBrowserLatestBlockId.apply(this, arguments);
      }
      return getBrowserLatestBlockId;
    }()
  }, {
    key: "beginManualProductionUI",
    value: function beginManualProductionUI(request) {
      this.produceUiRequest = request;
      this.setSimulationToolbarMessage('Mining Golden Ticket...');
      return startManualProductionCountdown(this.app, this, request);
    }
  }, {
    key: "stopManualProductionUI",
    value: function stopManualProductionUI() {
      stopManualProductionCountdown(this);
      this.produceUiRequest = null;
    }
  }, {
    key: "enterExplorerTestMode",
    value: function enterExplorerTestMode(app) {
      setExplorerTestMode(app, this);
    }
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19(app) {
        var tx,
          peer,
          mycallback,
          txmsg,
          gate,
          produceBlockHandlers,
          produceExplorerBlock,
          response,
          _args19 = arguments;
        return _regenerator().w(function (_context19) {
          while (1) switch (_context19.n) {
            case 0:
              tx = _args19.length > 1 && _args19[1] !== undefined ? _args19[1] : null;
              peer = _args19.length > 2 ? _args19[2] : undefined;
              mycallback = _args19.length > 3 ? _args19[3] : undefined;
              if (!(tx == null)) {
                _context19.n = 1;
                break;
              }
              return _context19.a(2, 0);
            case 1:
              if (!(app.BROWSER == 1)) {
                _context19.n = 2;
                break;
              }
              return _context19.a(2, _superPropGet(Explorer, "handlePeerTransaction", this, 3)([app, tx, peer, mycallback]));
            case 2:
              txmsg = tx.returnMessage();
              if (!((txmsg === null || txmsg === void 0 ? void 0 : txmsg.request) === EXPLORER_ENSURE_TEST_MODE_REQUEST)) {
                _context19.n = 4;
                break;
              }
              gate = ensureExplorerTestModeForManualAction(app, this);
              if (gate.ok) {
                _context19.n = 3;
                break;
              }
              if (mycallback) {
                mycallback(failure(gate.error));
              }
              return _context19.a(2, 1);
            case 3:
              if (mycallback) {
                mycallback(success({
                  accepted: true
                }));
              }
              return _context19.a(2, 1);
            case 4:
              if (!((txmsg === null || txmsg === void 0 ? void 0 : txmsg.request) === EXPLORER_SUBMIT_FEE_TRANSACTION_REQUEST)) {
                _context19.n = 5;
                break;
              }
              handleExplorerSubmitFeeTransaction(app, this, txmsg, mycallback);
              return _context19.a(2, 1);
            case 5:
              produceBlockHandlers = _defineProperty(_defineProperty({}, EXPLORER_PRODUCE_BLOCK_REQUEST, produceExplorerBlockWithoutGt), EXPLORER_PRODUCE_BLOCK_WITH_GT_REQUEST, produceExplorerBlockWithGt);
              produceExplorerBlock = produceBlockHandlers[txmsg === null || txmsg === void 0 ? void 0 : txmsg.request];
              if (!produceExplorerBlock) {
                _context19.n = 6;
                break;
              }
              logManualProduction("handlePeerTransaction: produce request received type=".concat(txmsg === null || txmsg === void 0 ? void 0 : txmsg.request, ", ") + "peer=".concat((peer === null || peer === void 0 ? void 0 : peer.publicKey) || '(unknown)'));
              runManualBlockProductionRequest(app, this, produceExplorerBlock, mycallback, txmsg === null || txmsg === void 0 ? void 0 : txmsg.request);
              return _context19.a(2, 1);
            case 6:
              _context19.n = 7;
              return handleExplorerRequest(app, txmsg, this);
            case 7:
              response = _context19.v;
              if (!(response !== null)) {
                _context19.n = 8;
                break;
              }
              if (!mycallback) {
                _context19.n = 8;
                break;
              }
              mycallback(response);
              return _context19.a(2, 1);
            case 8:
              return _context19.a(2, _superPropGet(Explorer, "handlePeerTransaction", this, 3)([app, tx, peer, mycallback]));
          }
        }, _callee19, this);
      }));
      function handlePeerTransaction(_x13) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }()
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20(app) {
        var _this13 = this;
        return _regenerator().w(function (_context20) {
          while (1) switch (_context20.n) {
            case 0:
              _context20.n = 1;
              return _superPropGet(Explorer, "initialize", this, 3)([app]);
            case 1:
              if (!(app.BROWSER == 0)) {
                _context20.n = 3;
                break;
              }
              this.database = new ExplorerDatabase(app, this);
              _context20.n = 2;
              return this.database.ensureSchema();
            case 2:
              setImmediate(function () {
                backfillSupplyStatistics(app, _this13)["catch"](function (err) {
                  console.error('Explorer: supply statistics backfill failed', err);
                });
              });
            case 3:
              if (!this.browser_active) {
                _context20.n = 5;
                break;
              }
              this.header = new SaitoHeader(this.app, this);
              _context20.n = 4;
              return this.header.initialize(this.app);
            case 4:
              this.bindNavigation();
            case 5:
              return _context20.a(2);
          }
        }, _callee20, this);
      }));
      function initialize(_x14) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21() {
        var route;
        return _regenerator().w(function (_context21) {
          while (1) switch (_context21.n) {
            case 0:
              _context21.n = 1;
              return _superPropGet(Explorer, "render", this, 3)([]);
            case 1:
              if (this.browser_active) {
                _context21.n = 2;
                break;
              }
              return _context21.a(2);
            case 2:
              if (!this.header) {
                _context21.n = 3;
                break;
              }
              _context21.n = 3;
              return this.header.render();
            case 3:
              this.ensureShell();
              route = this.parseRoute();
              if (!(route.view === 'block' && (route.input || route.hash))) {
                _context21.n = 5;
                break;
              }
              _context21.n = 4;
              return this.renderBlock(route.input || route.hash, {
                pushState: false,
                animate: false
              });
            case 4:
              return _context21.a(2);
            case 5:
              if (!(route.view === 'supply')) {
                _context21.n = 7;
                break;
              }
              _context21.n = 6;
              return this.renderSupply({
                pushState: false,
                animate: false
              });
            case 6:
              return _context21.a(2);
            case 7:
              if (!(route.view === 'address' && route.publicKey)) {
                _context21.n = 9;
                break;
              }
              _context21.n = 8;
              return this.renderAddress(route.publicKey, {
                pushState: false,
                animate: false
              });
            case 8:
              return _context21.a(2);
            case 9:
              if (!(route.view === 'utxo' && route.utxokey)) {
                _context21.n = 11;
                break;
              }
              _context21.n = 10;
              return this.renderUtxo(route.utxokey, {
                pushState: false,
                animate: false
              });
            case 10:
              return _context21.a(2);
            case 11:
              if (!(route.view === 'allBlocks')) {
                _context21.n = 13;
                break;
              }
              _context21.n = 12;
              return this.renderAllBlocks({
                pushState: false,
                animate: false
              });
            case 12:
              return _context21.a(2);
            case 13:
              if (!(route.view === 'allTransactions')) {
                _context21.n = 15;
                break;
              }
              _context21.n = 14;
              return this.renderAllTransactions({
                pushState: false,
                animate: false
              });
            case 14:
              return _context21.a(2);
            case 15:
              _context21.n = 16;
              return this.renderHome({
                pushState: false,
                animate: false
              });
            case 16:
              return _context21.a(2);
          }
        }, _callee21, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "onNewBlock",
    value: function () {
      var _onNewBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22(block, lc) {
        var _this$allBlocksCompon, addressRows, _t3, _t4;
        return _regenerator().w(function (_context22) {
          while (1) switch (_context22.p = _context22.n) {
            case 0:
              if (!(this.app.BROWSER == 1)) {
                _context22.n = 1;
                break;
              }
              (_this$allBlocksCompon = this.allBlocksComponent) === null || _this$allBlocksCompon === void 0 || _this$allBlocksCompon.onNewBlock(block, Boolean(lc));
              return _context22.a(2);
            case 1:
              if (!(!(block !== null && block !== void 0 && block.id) || !this.database)) {
                _context22.n = 2;
                break;
              }
              return _context22.a(2);
            case 2:
              if (!this.INDEX_BLOCKS) {
                _context22.n = 6;
                break;
              }
              _context22.p = 3;
              _context22.n = 4;
              return ensureBlockSupplyIndexed(this.app, this, block, {
                calculateSnapshot: Boolean(lc)
              });
            case 4:
              _context22.n = 6;
              break;
            case 5:
              _context22.p = 5;
              _t3 = _context22.v;
              console.error('Explorer: failed to record block statistics', _t3);
            case 6:
              if (this.INDEX_PUBLICKEYS) {
                _context22.n = 7;
                break;
              }
              return _context22.a(2);
            case 7:
              _context22.p = 7;
              addressRows = buildAddressRowsFromBlock(this.app, block, Boolean(lc));
              _context22.n = 8;
              return this.database.insertAddressRows(addressRows);
            case 8:
              if (blockContainsAtrTransaction(block)) {
                this.scheduleAddressPruningOnAtr(Number(block.id));
              }
              _context22.n = 10;
              break;
            case 9:
              _context22.p = 9;
              _t4 = _context22.v;
              console.error('Explorer: failed to record address activity', _t4);
            case 10:
              return _context22.a(2);
          }
        }, _callee22, this, [[7, 9], [3, 5]]);
      }));
      function onNewBlock(_x15, _x16) {
        return _onNewBlock.apply(this, arguments);
      }
      return onNewBlock;
    }()
  }, {
    key: "scheduleAddressPruningOnAtr",
    value: function scheduleAddressPruningOnAtr(blockId) {
      var _this14 = this;
      if (!Number.isFinite(blockId) || blockId <= 0 || !this.database) {
        return;
      }
      setImmediate(function () {
        _this14.database.pruneAddressesBeforeBlockId(blockId)["catch"](function (err) {
          console.error('Explorer: ATR address pruning failed', err);
        });
      });
    }
  }, {
    key: "onChainReorganization",
    value: function () {
      var _onChainReorganization = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23(block_id, block_hash, lc) {
        var _t5;
        return _regenerator().w(function (_context23) {
          while (1) switch (_context23.p = _context23.n) {
            case 0:
              if (!(this.app.BROWSER !== 0 || !this.database || !this.INDEX_PUBLICKEYS)) {
                _context23.n = 1;
                break;
              }
              return _context23.a(2);
            case 1:
              _context23.p = 1;
              _context23.n = 2;
              return this.database.updateAddressLongestChainState(block_id, block_hash, lc);
            case 2:
              _context23.n = 4;
              break;
            case 3:
              _context23.p = 3;
              _t5 = _context23.v;
              console.error('Explorer: failed to update address longest-chain state', _t5);
            case 4:
              return _context23.a(2);
          }
        }, _callee23, this, [[1, 3]]);
      }));
      function onChainReorganization(_x17, _x18, _x19) {
        return _onChainReorganization.apply(this, arguments);
      }
      return onChainReorganization;
    }()
  }, {
    key: "webServer",
    value: function webServer(app, expressapp, express) {
      var alternative_slug = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var webdir = "".concat(__dirname, "/../../mods/").concat(this.dirname, "/web");
      var uri = alternative_slug || '/' + encodeURI(this.returnSlug());
      var self = this;
      expressapp.use(uri, express["static"](webdir));
      var sendIndex = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24(req, res) {
          var html;
          return _regenerator().w(function (_context24) {
            while (1) switch (_context24.n) {
              case 0:
                html = index(app, self, app.build_number);
                res.setHeader('Content-type', 'text/html');
                res.charset = 'UTF-8';
                return _context24.a(2, res.send(html));
            }
          }, _callee24);
        }));
        return function sendIndex(_x20, _x21) {
          return _ref2.apply(this, arguments);
        };
      }();

      // Legacy query-parameter URLs are permanently redirected (HTTP 301) to
      // their canonical REST-style equivalents so old bookmarks, links, and
      // search-engine results keep working while the explorer exposes a single
      // canonical URL per resource. The supplied identifier is preserved
      // exactly (encoded the same way the canonical routes are generated);
      // missing/blank parameters fall back gracefully to the explorer home.
      var firstQueryValue = function firstQueryValue(value) {
        return Array.isArray(value) ? value[0] : value;
      };

      // /explorer/balance?pubkey=<key>  ->  /explorer/address/<key>
      expressapp.get("".concat(uri, "/balance"), function (req, res) {
        var pubkey = firstQueryValue(req.query.pubkey);
        if (typeof pubkey === 'string' && pubkey.trim() !== '') {
          return res.redirect(301, "".concat(uri, "/address/").concat(encodeURIComponent(pubkey)));
        }
        return res.redirect(301, uri);
      });

      // /explorer/block?hash=<hash>  ->  /explorer/block/<hash>
      expressapp.get("".concat(uri, "/block"), function (req, res) {
        var hash = firstQueryValue(req.query.hash);
        if (typeof hash === 'string' && hash.trim() !== '') {
          return res.redirect(301, "".concat(uri, "/block/").concat(encodeURIComponent(hash)));
        }
        return res.redirect(301, uri);
      });
      expressapp.get("".concat(uri, "/data"), /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee25(req, res) {
          var _t6, _t7;
          return _regenerator().w(function (_context25) {
            while (1) switch (_context25.p = _context25.n) {
              case 0:
                res.setHeader('Cache-Control', 'no-store');
                _context25.p = 1;
                _t6 = res;
                _context25.n = 2;
                return buildExplorerApiData(app, self);
              case 2:
                return _context25.a(2, _t6.json.call(_t6, _context25.v));
              case 3:
                _context25.p = 3;
                _t7 = _context25.v;
                console.error('Explorer: failed to build API data', _t7);
                return _context25.a(2, res.status(503).json({
                  error: 'Explorer data is temporarily unavailable.'
                }));
            }
          }, _callee25, null, [[1, 3]]);
        }));
        return function (_x22, _x23) {
          return _ref3.apply(this, arguments);
        };
      }());
      expressapp.get("".concat(uri, "/block/:input"), sendIndex);
      expressapp.get("".concat(uri, "/blocks"), sendIndex);
      expressapp.get("".concat(uri, "/transactions"), sendIndex);
      expressapp.get("".concat(uri, "/supply"), sendIndex);
      expressapp.get("".concat(uri, "/address/:publickey"), sendIndex);
      expressapp.get("".concat(uri, "/utxo/:utxokey"), sendIndex);
      expressapp.get(uri, sendIndex);
    }
  }]);
}(ModTemplate);
module.exports = Explorer;